import React, { useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { Toast } from 'primereact/toast';
import axios from 'axios';
import { classNames } from 'primereact/utils';
import useUserRole from '../hooks/useUserRole';
import useAppRoot from '../hooks/useAppRoot';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

const QuotationSummary = ({ quotation }) => {
    const toast = useRef(null);
    const role = useUserRole();
    const appRoot = useAppRoot();
    const menuStates = useRef(null);
    const [updatingStatus, setUpdatingStatus] = useState(false);
    const [reorderingStatus, setReorderingStatus] = useState(false);

    const reOrder = () => {
        confirmDialog({
            message: '¿Seguro que desea volver a ordenar esta cotización?',
            header: 'Volver a ordenar',
            acceptLabel: 'Sí',
            accept: () => {
                setReorderingStatus(true);
                axios
                    .post('/quotations/' + quotation.id_registro + '/reOrder')
                    .then((response) => {
                        toast.current.clear();
                        toast.current.show({ severity: 'success', detail: 'Se ha generado un nuevo registro' });

                        window.location = appRoot + '/seguimiento/' + response.data;
                    })
                    .catch(() => {
                        setReorderingStatus(false);
                    })
                    .finally(() => {
                        setReorderingStatus(false);
                    });
            },
        });
    };

    const updateStatus = (newStatus) => {
        confirmDialog({
            message: '¿Seguro que desea cambiar el estado de esta cotización a ' + newStatus + ' ?',
            header: 'Cambio de estado',
            acceptLabel: 'Sí',
            accept: () => {
                setUpdatingStatus(true);
                axios
                    .patch('/quotations/' + quotation.id_registro + '/status', {
                        status: newStatus,
                    })
                    .then(() => {
                        // setUpdatingStatus(false);

                        toast.current.clear();
                        toast.current.show({ severity: 'success', detail: 'Se ha actualizado el estado de la cotización' });

                        if (newStatus === 'Eliminado') {
                            window.location = appRoot + '/seguimiento';
                        } else {
                            window.location.reload();
                        }
                    })
                    .catch(() => {
                        setUpdatingStatus(false);
                    });
            },
        });
    };

    const menuItems = [];

    if (quotation.estado === 'Cotizado') {
        menuItems.push({
            label: 'Pagado',
            command: (evt) => {
                evt.originalEvent.stopPropagation();
                updateStatus('Pagado');
            },
        });
    }

    // if (quotation.estado === 'Pagado') {
    //     menuItems.push({
    //         label: 'Cotizado',
    //         command: (evt) => {
    //             evt.originalEvent.stopPropagation();
    //             updateStatus('Cotizado');
    //         },
    //     });
    // }

    menuItems.push({
        label: 'Eliminado',
        command: (evt) => {
            evt.originalEvent.stopPropagation();
            updateStatus('Eliminado');
        },
    });

    return (
        <div>
            <Toast ref={toast} position="bottom-right" />
            <div className="card-body">
                <div className="grid mt-3">
                    <div className="row">
                        <h4>Solicitud #{quotation.id_registro}</h4>
                        <div className="row pt-2">
                            <div className="col-10">
                                <div className="row">
                                    <div className="col-md-6 pb-2">
                                        <span className="form-label fw-bold">Nombre: </span> {quotation.nombre}
                                    </div>
                                    <div className="col-md-6 pb-2">
                                        <span className="form-label fw-bold">Fecha: </span> {quotation.creacion}
                                    </div>
                                    <div className="col-md-6 pb-2">
                                        <span className="form-label fw-bold">Estado: </span>{' '}
                                        <span className={classNames('badge', quotation.estado.toLowerCase())}>{quotation.estado}</span>
                                    </div>
                                    <div className="col-md-6 pb-2">
                                        <span className="form-label fw-bold">Precio: </span>{' '}
                                        {new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(quotation.precio)}
                                    </div>

                                    <div className="col-md-6 pb-2">
                                        <span className="form-label fw-bold">Teléfono: </span>

                                        {role === 1 ? (
                                            <>
                                                <a
                                                    className="link"
                                                    aria-current="page"
                                                    href={'https://wa.me/' + quotation.telefono}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <i className="fa-brands fa-whatsapp"></i>
                                                    <span> {quotation.telefono}</span>
                                                </a>
                                            </>
                                        ) : (
                                            <>{quotation.telefono}</>
                                        )}
                                    </div>
                                    <div className="col-md-6 pb-2">
                                        <span className="form-label fw-bold">Correo: </span> <a href={'mailto:' + quotation.mail}>{quotation.mail}</a>
                                    </div>
                                    <div className="col-12 pb-2">
                                        <span className="form-label fw-bold">Modo de entrega: </span>{' '}
                                        {{ retiro_tienda: 'Retiro en tienda', envio_domicilio: 'Envío a domicilio' }[quotation.metodo_entrega]}
                                    </div>

                                    {quotation.metodo_entrega === 'envio_domicilio' && (
                                        <>
                                            <div className="col-md-6 pb-2">
                                                <span className="form-label fw-bold">Dirección de envío: </span> {quotation.direcciondespacho}
                                            </div>
                                            <div className="col-md-6 pb-2">
                                                <span className="form-label fw-bold">Departamento: </span> {quotation.departamento_despacho}
                                            </div>
                                            <div className="col-md-6 pb-2">
                                                <span className="form-label fw-bold">Block: </span> {quotation.block_despacho}
                                            </div>
                                            <div className="col-md-6 pb-2">
                                                <span className="form-label fw-bold">Comuna: </span> {quotation.comunadespacho}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className="col-2">
                                {role === 1 && (
                                    <div className="row pb-2">
                                        <Menu model={menuItems} popup ref={menuStates} />
                                        <Button
                                            className="text-nowrap"
                                            label="Cambiar estado"
                                            severity="secondary"
                                            loading={updatingStatus}
                                            onClick={(event) => menuStates.current.toggle(event)}
                                        />
                                    </div>
                                )}
                                {role === 2 && <ConfirmDialog />}
                                <div className="row">
                                    <Button className="text-nowrap" label="Volver a ordenar" loading={reorderingStatus} onClick={() => reOrder()} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuotationSummary;
